import { faBook, faFileSignature, faUsers } from "@fortawesome/free-solid-svg-icons";
import { createModuleExtensionHost } from "../../modules/extensions/createModuleExtensionHost";

export default createModuleExtensionHost({
  moduleKey: "hr",
  scriptUrl: "/hr/extensions/index.js",
  styleUrl: "/hr/extensions/index.css",
  sdk: { icons: { faBook, faFileSignature, faUsers } },
});
